import { render, staticRenderFns } from "./StudentDetail.vue?vue&type=template&id=c378245e&scoped=true&"
import script from "./StudentDetail.vue?vue&type=script&lang=js&"
export * from "./StudentDetail.vue?vue&type=script&lang=js&"
import style0 from "./StudentDetail.vue?vue&type=style&index=0&id=c378245e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c378245e",
  null
  
)

export default component.exports